// extracted by mini-css-extract-plugin
module.exports = {"feedCount":"_2Eji9 _25dm- _1R_Wx"};